import { InfoInputField, RelevantUserInfo, UserInfoInputCombinedRequirement } from './user-info-input-fields';

export type UserInfoInputGroups = Array<{
  titleI18n: string;
  inputs: ReadonlyArray<InfoInputField<RelevantUserInfo>>;
}>;


export class UserInfoInputConfig {
  constructor(
    public readonly inputGroups: UserInfoInputGroups,
    public readonly combinedRequiredInputs: ReadonlyArray<UserInfoInputCombinedRequirement>,
  ) {}
}
